export function ResourcesPage () {
  return (
    <div>
      <h1 className='heading-lg mb-6'>Resources</h1>
    </div>
  )
}
